<template><section><h1>icon 字体图标</h1>
<p>圆形头像</p>
<h2 id="dai-ma-yan-shi"><a class="header-anchor" href="#dai-ma-yan-shi">¶</a> 代码演示</h2>
<h3 id="ji-chu-ying-yong"><a class="header-anchor" href="#ji-chu-ying-yong">¶</a> 基础应用</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;\n&lt;com-icon name=\&quot;shrink\&quot;&gt;&lt;/com-icon&gt;\n\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source">
<com-icon name="shrink"></com-icon>

</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">com-icon</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"shrink"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">com-icon</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3 id="zhi-jie-shi-yong-lei-ming"><a class="header-anchor" href="#zhi-jie-shi-yong-lei-ming">¶</a> 直接使用类名</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;\n&lt;i class=\&quot;com-icon-blow\&quot;&gt;&lt;/i&gt;\n\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source">
<i class="com-icon-blow"></i>

</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">i</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"com-icon-blow"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">i</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3 id="mu-qian-tu-biao"><a class="header-anchor" href="#mu-qian-tu-biao">¶</a> 目前图标</h3>


<ul class="icon-list">
  <li v-for="name in icons" :key="name">
    <i :class="'com-icon-' + name"></i>
    <span>com-icon-{{name}}</span>
  </li>
</ul>
<h3 id="props"><a class="header-anchor" href="#props">¶</a> Props</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
<th>是否必填</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>icon的名字</td>
<td>String</td>
<td>—</td>
<td>—</td>
<td>yes</td>
</tr>
</tbody>
</table>
</section></template>
<style>

.demo-icon [class^="com-icon"] {
  margin: 0 10px;
  font-size: 24px;
  vertical-align: middle;
}

ul.icon-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-radius: 4px;
}
ul.icon-list li {
  width: 130px;
  padding: 10px 0;
  text-align: center;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  list-style: none;
}
ul.icon-list li + li {
  margin-top: 0;
}
.icon-list i {
  font-size: 24px;
}
.icon-list span {
  display: block;
}

.icon-box [class^="com-icon"] {
  font-size: 14px;
}

</style>
<script>
  export default {
    data() {
      return {
        icons: ['shrink', 'blow', 'circle-question']
      };
    }
  };
</script>